import ImageUploading from 'react-images-uploading';
import React, { useState, useRef } from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Button, Typography } from '@material-ui/core';
import BackupIcon from '@material-ui/icons/Backup';
import { SecondaryButton } from '../../../../../Core/Controls';

import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import DialogComp from '../../../../../Core/Dialog/DialogComp';
import { useWindowSize } from '../../../../../Core/Hooks/useWindowSize';
import ImageCard from '../DriverDailyChecks/imageCard';

const ImageUpload = (props) => {
    const { disabled, state, onImageChange, submitImage, onClose, maxNumber, RemoveImage, isAPI, loader } = props;

    const showDialog = props.showDialog === undefined ? true : !!props.showDialog;

    const [windowWidth] = useWindowSize();

    let imageSizeLimit = { height: 800, width: 800 };

    const localRef = useRef(null);
    const fileInputRef = props.fileInputRef || localRef;

    const resizeImage = (image, maxWidth, maxHeight) => {
        return new Promise((resolve) => {
            imageSizeLimit = { height: maxHeight, width: maxWidth };
            const img = new Image();
            img.src = image.data_url;

            const canvas = document.createElement('canvas');
            document.body.append(canvas);
            canvas.style.display = 'none';
            const ctx = canvas.getContext('2d');
            img.onload = () => {
                let ch = img.height;
                let cw = img.width;

                // Calculate aspect ratio and resize based on fixed width and height
                if (ch > imageSizeLimit.height || cw > imageSizeLimit.width) {
                    if (ch > cw) {
                        const ratio = imageSizeLimit.height / ch;
                        cw = cw * ratio;
                        ch = imageSizeLimit.height;
                    } else {
                        const ratio = imageSizeLimit.width / cw;
                        ch = ch * ratio;
                        cw = imageSizeLimit.width;
                    }
                }
                if (ch > imageSizeLimit.height) {
                    const ratio = imageSizeLimit.height / ch;
                    cw = cw * ratio;
                    ch = imageSizeLimit.height;
                }
                if (cw > imageSizeLimit.width) {
                    const ratio = imageSizeLimit.width / cw;
                    ch = ch * ratio;
                    cw = imageSizeLimit.width;
                }

                canvas.height = ch;
                canvas.width = cw;

                // Draw image to canvas
                ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, cw, ch);

                // Convert canvas to data URL (base64)
                const dataUrl = canvas.toDataURL('image/jpeg', 0.8); // You can adjust the quality from 0 to 1
                resolve({ ...image, data_url: dataUrl });
            };
        });
    };

    const getCompressedSize = (base64String) => {
        if (base64String) {
            let stringLength = base64String.length - 'data:image/jpeg;base64,'.length;
            let sizeInBytes = 4 * Math.ceil(stringLength / 3) * 0.5624896334383812;
            return sizeInBytes / 1024;
        }
    };

    const onCompressedImageChange = (imageList) => {
        console.log(imageList, 'imageList');
        const resizedImages = imageList.map((image) => {
            if (image.data_url) {
                return resizeImage(image, 800, 800);
            } else {
                return image;
            }
        });

        Promise.all(resizedImages).then((newImages) => {
            onImageChange(newImages);
            newImages.forEach((image) => {
                console.log('Compressed Image Size:', getCompressedSize(image.data_url), 'KB');
            });
        });
    };

    const [image, setImage] = useState();
    const [activeImageIndex, setActiveImageIndex] = useState(0);

    const scrollNext = (id) => {
        document.getElementById('slider-scroll').scrollBy({ left: 100, top: 0, behavior: 'smooth' });
    };

    const scrollPrev = (id) => {
        document.getElementById('slider-scroll').scrollBy({ left: -100, top: 0, behavior: 'smooth' });
    };

    const setCurrentImage = (img, index) => {
        setImage(img);
        setActiveImageIndex(index);
    };

    const TitleComp = (props) => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>Upload Image {props.inspectionDesc}</div>
            </div>
        );
    };

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;

        const array = [...(state.selectedImages || [])];

        const readPromises = files.map((file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve({
                        data_url: reader.result,
                        file: file
                    });
                };
                reader.readAsDataURL(file);
            });
        });

        Promise.all(readPromises).then((fileObjects) => {
            const newArray = [...array, ...fileObjects];
            onCompressedImageChange(newArray);
        });

        if (e.target) {
            e.target.value = '';
        }
    };

    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
            fileInputRef.current.click();
        }
    };

    return (
        <div>
            <ImageUploading multiple value={state.selectedImages} onChange={onCompressedImageChange} maxNumber={maxNumber} dataURLKey="data_url">
                {({ imageList, onImageUpload, onImageRemove }) => {
                    const currentDisplayImage = imageList[activeImageIndex] || (!image || !imageList.includes(image) ? imageList[0] : image);

                    return (
                        <>
                            <input
                                type="file"
                                accept="image/*, application/pdf, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                onChange={handleImageChange}
                                id="file-input"
                                multiple
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                            {showDialog && (
                                <DialogComp
                                    title={<TitleComp onImageUpload={onImageUpload} />}
                                    onClose={onClose}
                                    maxWidth="md"
                                    fullWidth
                                    className="dialog-container"
                                >
                                    <div className="avatar">
                                        {disabled ? null : (
                                            <div>
                                                <Button variant="contained" color="primary" onClick={handleButtonClick}>
                                                    <BackupIcon /> {windowWidth <= 900 ? '' : `\u00a0 Add Image`}
                                                </Button>{' '}
                                            </div>
                                        )}
                                        {imageList.length > 0 ? (
                                            <ImageCard avtar={currentDisplayImage} />
                                        ) : (
                                            <div className="image-card" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Typography>No image found</Typography>
                                            </div>
                                        )}
                                        <div className="carousel-wrapper-class">
                                            <div className="other-images d-flex" id={'slider-scroll'}>
                                                {imageList.map((im, i) => (
                                                    <span className="other-image" style={{ position: 'relative' }} key={i}>
                                                        {disabled ? null : loader ? null : (
                                                            <>
                                                                {isAPI ? (
                                                                    <span style={{ position: 'absolute', top: '-8px', right: '-10px', zIndex: 10000000 }}>
                                                                        <RemoveCircleIcon
                                                                            onClick={() => {
                                                                                RemoveImage(im, i);
                                                                                if (activeImageIndex >= i) {
                                                                                    setActiveImageIndex(Math.max(0, activeImageIndex - 1));
                                                                                }
                                                                                setImage(undefined);
                                                                            }}
                                                                            style={{ fill: '#f44336', cursor: 'pointer' }}
                                                                        />
                                                                    </span>
                                                                ) : (
                                                                    <span style={{ position: 'absolute', top: '-8px', right: '-10px', zIndex: 10000000 }}>
                                                                        <RemoveCircleIcon
                                                                            onClick={() => {
                                                                                onImageRemove(i);
                                                                                if (activeImageIndex >= i) {
                                                                                    setActiveImageIndex(Math.max(0, activeImageIndex - 1));
                                                                                }
                                                                                setImage(undefined);
                                                                            }}
                                                                            style={{ fill: '#f44336', cursor: 'pointer' }}
                                                                        />
                                                                    </span>
                                                                )}
                                                            </>
                                                        )}
                                                        <img
                                                            className={i === activeImageIndex ? 'active' : ''}
                                                            onClick={() => setCurrentImage(im, i)}
                                                            src={im}
                                                        />
                                                    </span>
                                                ))}
                                                <div className="arrow">
                                                    <span className="arrow-left" onClick={() => scrollPrev()}>
                                                        <ChevronLeftIcon />
                                                    </span>
                                                    <span className="arrow-right" onClick={() => scrollNext()}>
                                                        <ChevronRightIcon />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        {disabled ? null : (
                                            <div style={{ marginTop: '5px' }}>
                                                <SecondaryButton onClick={submitImage} disabled={!state.showSubmit}>
                                                    Submit
                                                </SecondaryButton>
                                            </div>
                                        )}
                                    </div>
                                </DialogComp>
                            )}
                        </>
                    );
                }}
            </ImageUploading>
        </div>
    );
};

export default ImageUpload;
